import { TEXT_DISPLAY_NAME } from "./core";
import createDisplayName from "../../../../fabrics/createDisplayName";

export const createDisplayNameForTextElement =
    createDisplayName(TEXT_DISPLAY_NAME);
